// employee constants
import {
  RESET_GOOGLE_SIGNUP,
  GOOGLE_SIGNUP,
  GOOGLE_SIGNUP_SUCCESS,
  GOOGLE_SIGNUP_FAILURE,
} from "../../constants/Google/Google_signup";
import { jwtDecode as jwt } from "jwt-decode"; // import dependency

const INIT_STATE = {
  googleSignupInfo: {},
  loadingGoogleSignupInfo: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case RESET_GOOGLE_SIGNUP:
      return INIT_STATE;

    case GOOGLE_SIGNUP:
      return {
        ...state,
        loadingGoogleSignupInfo: true,
      };
    case GOOGLE_SIGNUP_SUCCESS:
      if (action.payload.ok) {
        // Google LOGIN returns the same body as password login (createJWT -> buildAuthResponse),
        // so persist the permission table here too. hasPermission() reads localStorage
        // synchronously and is not reactive, so skipping this left the sidebar and other gated UI
        // on a stale table until AppInitializer refetched on the next full page reload.
        //
        // This same action is also dispatched by Settings -> Password to LINK a Google account
        // (customerUser/:userId/linkGoogle), which replies 200 with no permissions/features. Only
        // write when both arrays are actually present, otherwise linking would wipe the table of
        // an already-signed-in user. Mirrors the guard in services/rbac.ts.
        // Written before the jwt() decode below so a bad token cannot skip it.
        const { permissions, features } = action.payload?.payload || {};
        if (Array.isArray(permissions) && Array.isArray(features)) {
          localStorage.setItem("permissionTable", JSON.stringify({ permissions, features }));
        }

        const user = jwt(action.payload?.payload?.accessToken); // decode your token here

        localStorage.setItem("accessToken", action.payload?.payload?.accessToken);
        localStorage.setItem("loggedInUser", JSON.stringify(user));
        localStorage.setItem("refreshToken", action.payload?.payload?.refreshToken);
        return {
          ...state,
          loadingGoogleSignupInfo: false,
          googleSignupInfo: action.payload,
        };
      }
      return {
        ...state,
        loadingGoogleSignupInfo: false,
        googleSignupInfo: action.payload,
      };

    // eslint-disable-next-line no-fallthrough
    case GOOGLE_SIGNUP_FAILURE:
      localStorage.removeItem("accessToken");
      return {
        ...state,
        loadingGoogleSignupInfo: false,
        googleSignupInfo: "Error in  getting Customer Data",
      };
    default:
      return state;
  }
};
